import { StyleSheet } from "@react-pdf/renderer"
import { colors, reduce } from "../styles"

export const styles = StyleSheet.create({
  boxFilters: {
    borderRadius: 4,
    fontSize: 7,
    border: `1px solid ${colors.gray["20"]}`,
    height: "auto",
    padding: 6,
    marginBottom: 16,
  },
  title: {
    fontSize: 10 - reduce,
    lineHeight: 1,
    color: colors.gray[8],
    fontWeight: 700,
    marginBottom: 3,
  },
  wrapperFilters: {
    flexDirection: "row",
    gap: 10,
    height: "auto",
    width: "100%",
  },
  containerFilters: {
    flexDirection: "row",
    gap: 7,
    height: "auto",
  },
  listFilter: {
    maxWidth: "37%",
  },
  label: {
    fontSize: 8 - reduce,
    color: `${colors.gray["30"]}`,
    marginBottom: 3,
    fontWeight: 600,
    lineHeight: 1,
  },
  element: {
    fontSize: 8 - reduce,
    color: `${colors.gray[8]}`,
    fontWeight: 600,
    lineHeight: 1,
  },
})
